import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import UserHeaderNav from "./UserHeaderNav";
import Footer from "../../Component/Footer";
import { getProfile } from "../../store/slices/profile";

export default function Dashboardlayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { profilelist = {} } = useSelector((state) => state.profile);

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Aadhaar verification check
  useEffect(() => {
    if (
      profilelist &&
      profilelist.aadhaarVerified === false &&
      location.pathname !== "/user/verify-aadhaar"
    ) {
      navigate("/user/verify-aadhaar", { replace: true });
    }
  }, [profilelist, location.pathname, navigate]);

  return (
    <>
      <div className="app-wrapper">
        <UserHeaderNav onMenuClick={() => setSidebarOpen(!sidebarOpen)} />

        <div className="content">
          <Outlet />
        </div>
      </div>

      <Footer />
    </>
  );
}